               <!-- <table class="table table-sm">
                  <tbody>
                     <tr v-for="fila in productos" :key="fila">
                        <td v-for="producto in fila" :key="producto">
                           {{ producto }}
                        </td>
                     </tr>
                  </tbody>
               </table> -->
<template>
   <div class="container .productos">
      <div class="container section text-center pt-3">
         <h2>Nuestros productos</h2>
         <div class="row" v-for="fila_producto in productos" :key="fila_producto[0]">
            <div class="col-sm-4">
               <p><b>{{ fila_producto[0] }}</b></p>
            </div>
            <div class="col-sm-4">
               <p><b>{{ fila_producto[1] }}</b></p>
            </div>
            <div class="col-sm-4">
               <p><b>{{ fila_producto[2] }}</b></p>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
   export default {
      name: 'productos',
      data(){
         return{
            productos: [
               ["GALLETA DE  COCO","PAN  DE  SAL","PAN TAJADO  CASERO"],
               ["GALLETA DE  QUESO","PAN  DE UVA","PAN TAJADO DE LECHE"],
               ["GALLETA DE LIMON","PAN ALIÑADO DE QUESO","PAN TAJADO MEDIO DE LECHE"],
               ["GALLETA DE NARANJA" ,"PAN DE LECHE","PAN TAJADO PREMIUM"],
               ["LENGUA","PAN DIABOLIN","PASTELITO"],
               ["LOLITA","PAN HAMBURGUESA","ROSCÓN DE QUESO"],
               ["MOGOLLA MORENA DE TRIGO","PAN MANTEQUILLA","ROSQUITAS"],
               ["MOGOLLA ALIÑADA","PAN OCAÑERO","TORTAS CASERA"],
               ["PALITROQUE","PAN QUESO POPULAR","TOSTADA"],
               ["PAN CASERO","PAN QUESO EFECTIVO",""]
            ],
         }
      }
   };
</script>
<style>
   .productos {
      min-height: calc(100vh - 200px);
   }
</style>